import request from '@/plugin/axios'

export function GetAssistItems () {
  return request({
    url: '/study/assist-items',
    method: 'get'
  })
}

export function ListStudys (data) {
  return request({
    url: '/study/index',
    method: 'get',
    params: data
  })
}

export function FetchMineStudy (data) {
  return request({
    url: '/study/list-mine',
    method: 'get',
    params: data
  })
}

export function CreateStudy (data) {
  return request({
    url: '/study/create',
    method: 'post',
    data
  })
}

export function ViewStudy (id) {
  return request({
    url: '/study/view?id=' + id,
    method: 'get'
  })
}

export function UpdateStudy (data) {
  return request({
    url: '/study/view?id=' + data.id,
    method: 'post',
    data
  })
}

export function MarkStatus (id, data) {
  return request({
    url: '/study/mark-status?id=' + id,
    method: 'post',
    data
  })
}

export function DeleteStudy (id) {
  return request({
    url: '/study/delete?id=' + id,
    method: 'post'
  })
}

export function SummaryStudy (id) {
  return request({
    url: '/study/summary?id=' + id,
    method: 'get'
  })
}
